import React from "react";
import { Row, Col } from 'reactstrap';
import styles from './Navbar.module.scss'

const breakingNews = window._edo_settings.breaking_news;

const Ribbon = () => {
  return (
    <>
      {breakingNews.active ? 
        <Row className={styles.navRibbonWidth}>
          <Col className={styles.navRibbon}>
            <p className='text-center m-0'>
              {breakingNews.text}
              <a className={styles.navRibbonLink} href={breakingNews.link}>Find out more</a>
            </p>
          </Col>
        </Row>
      : null}
    </>
  )
}

export default Ribbon;